import { render, staticRenderFns } from "./RxParserAlternatives.vue?vue&type=template&id=d9c48da4&scoped=true&"
import script from "./RxParserAlternatives.vue?vue&type=script&lang=js&"
export * from "./RxParserAlternatives.vue?vue&type=script&lang=js&"
import style0 from "./RxParserAlternatives.vue?vue&type=style&index=0&id=d9c48da4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c48da4",
  null
  
)

export default component.exports